import React from "react";
import { useI18n } from "@/i18n/I18nContext";

export default function Step5Summary({ form }) {
  const { t } = useI18n();
  const rows = [
    [t("wizard.styleLabel"), t(`options.style_${form.style}`)],
    [t("wizard.moodLabel"), t(`options.mood_${form.mood}`)],
    [t("wizard.songLanguageLabel"), t(`wizard.lang_${form.song_language}`)],
    [t("wizard.durationLabel"), `${form.duration_minutes} min`],
    [t("wizard.versionsLabel"), form.num_versions],
    [t("wizard.lyricsModeLabel"), form.lyrics_mode === "auto" ? t("wizard.lyricsAuto") : t("wizard.lyricsCustom")],
    [t("wizard.voiceLabel"), form.voice_enabled ? `${form.voice_gender === "homme" ? t("wizard.voiceHomme") : t("wizard.voiceFemme")} - ${form.vocal_style}` : t("common.no")],
    [t("wizard.thumbnailLabel"), form.thumbnail_ai ? t("common.yes") : t("common.no")],
    [t("wizard.titleModeLabel"), form.title_mode === "auto" ? t("wizard.titleAuto") : form.custom_title],
    [t("wizard.voiceMessageLabel"), form.personal_voice_message ? t(`wizard.voiceMessagePosition${form.voice_message_position.charAt(0).toUpperCase()}${form.voice_message_position.slice(1)}`) : t("common.no")],
  ];

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border border-border bg-card/50 p-6">
        <h3 className="font-heading text-lg font-medium">{t("wizard.summaryTitle")}</h3>
        <dl className="mt-4 divide-y divide-border">
          {rows.map(([label, value]) => (
            <div key={label} className="flex justify-between py-2.5 text-sm">
              <dt className="text-muted-foreground">{label}</dt>
              <dd className="max-w-[60%] truncate text-right font-medium">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
